import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Selectbox from '../../Selectbox';
import { changeFilter } from '../../../services/carts/actions';

const sortBy = [
  { value: '', label: 'Select' },,
  { value: 'name', label: 'Sort by Title' },
  { value: 'lowToHigh', label: 'Price: Low to High' },
  { value: 'highToLow', label: 'Price: High to Low' }
];

const Sort = ({ changeFilter }) => (
  <div className="sort">
    Order by
    <Selectbox options={sortBy} handleOnChange={value => changeFilter(value)} />
  </div>
);

Sort.propTypes = {
  changeFilter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  filter: state.carts.filter
});

export default connect(
  mapStateToProps,
  { changeFilter }
)(Sort);
